import { action } from 'mobx';
import Queries from 'src/services/graphql/queries/index';
import { CommCacheInput, GetCommCacheInput } from 'src/services/graphql/Models';
import CommCache from './classes/CommCache';
import DataStoreExtension from './generic/datastore';
import { DocumentNode } from 'graphql';
import { getFirstKey, processArrayAsync } from 'src/shared/utility';
import GetCommCache from 'src/shared/GetCommCache';

export class CommCacheStore extends DataStoreExtension<CommCacheInput, CommCache> {
    listQueries: DocumentNode =  Queries.ListUnitComms;
    _listVariables: GetCommCache[] = [];
    _createQueries = undefined;
    _updateQueries = undefined;
    _deleteQueries = undefined;
    
    listVariables: () => { input: GetCommCacheInput }[] = () => {
        const ret = (this._listVariables || []).map( variable => ({ input: variable.getData() }) );
        return ret;
    }

    _allSubscriptions = ({variables}: {variables: GetCommCacheInput}) =>  [{
        document: Queries.CommSubscription,
        updateQuery: (prev, { subscriptionData }) => {
            const startTime = Date.now();
            let prevKey = getFirstKey(prev);
            if (
                !subscriptionData.data ||
                variables.unitId !== subscriptionData.data.unitId ||
                !prevKey ||
                typeof prev[prevKey] === 'undefined' ||
                !Array.isArray(prev[prevKey].items)
            ) { 
                return prev;
            }
            let newItem = subscriptionData.data;
            let newItemsIndex = getFirstKey(newItem);
            if (newItemsIndex !== false) {
                newItem = newItem[newItemsIndex];
            }
            
            let { items } = prev[prevKey];
            let itemIndex = items.findIndex(o => o.typedId === newItem.typedId);
            
            let _items;
            if (
                itemIndex >= 0 &&
                itemIndex < items.length
            ) {
                _items = [
                    ...items.slice(0, itemIndex),
                    Object.assign({}, items[itemIndex], newItem),
                    ...items.slice(itemIndex + 1, items.length)
                ];
            } else {
                _items = [newItem, ...items];
            }

            let ret = Object.assign({}, prev, {
                [prevKey]: {
                    ...prev[prevKey],
                    items: _items, 
                }
            });
            console.debug(`UpdateQuery Timespan: ${Date.now() - startTime}`);
            return ret;
        }
    }]

    constructor() {
        super(false);
        (window as any).CommStore = this;
        const updateProcess = (data, {gqlObject}) => {
            if (
                gqlObject &&
                gqlObject.data &&
                gqlObject.data.listUnitComms &&
                gqlObject.data.listUnitComms.items
            ) {
                const { data : { updateSubscribers }} = data;
                const actualData = updateSubscribers.cc;

                const gqlObjectData = gqlObject.data;
                const currentItems =  gqlObjectData.listUnitComms.items;
                
                let mutated = false;
                const updatedItems = currentItems.map(item => {
                    let dataIndex = actualData.findIndex(o => item.unitId === o.unitId && item.typedId === o.typedId);
                    if (
                        dataIndex >= 0 ||
                        dataIndex < actualData .length
                    ) {
                        mutated = true;
                        return Object.assign({}, item, actualData [dataIndex]);
                    }
                    return item;
                });

                actualData.forEach(o => {
                    if ( updatedItems.every(
                        updatedItem => updatedItem.typedId !== o.typedId &&
                        updatedItem.unitId === o.unitId
                    )) {
                        mutated = true;
                        updatedItems.push(o);
                    }
                });

                if (mutated) {
                    gqlObject.update({
                        ...gqlObjectData, 
                        listUnitComms: {
                            ...gqlObjectData.listUnitComms,
                            items : updatedItems 
                        } 
                    });
                }
            }
        };

        this.subscriptionToUpdate(
            {
                next: (data) => {
                    if (Array.isArray(this.lastQuery)) {
                        processArrayAsync(this.lastQuery, updateProcess.bind(this, data));
                    } else {
                        updateProcess(data, this.lastQuery);
                    }
                    // this.updateQueryResult(data);
                }
            }
        );
        // observe(this, 'getParsedItems', (change) => console.log(change));
    }

    @action _putCommCacheInputUpdate(variableIndex: number) {
        this.updateQuery(variableIndex);
    }

    putCommCacheInput(input: GetCommCache) {
        let variableIndex = this._listVariables
            .findIndex(v => v.isRelated(input));
        let mutated: boolean = false;
        if (
            variableIndex >= 0 &&
            variableIndex < this._listVariables.length
        ) {
            mutated = this._listVariables[variableIndex]
                .updateComms(input);
        } else {
            variableIndex = this._listVariables.length;
            this._listVariables.push(input);
            mutated = true; 
        }

        if (mutated) {
            setTimeout( 
                ((_variableIndex: any) => {
                    this._putCommCacheInputUpdate(_variableIndex);
                }).bind(this, variableIndex), 
                1500
            );
            
        }

    }
    toObject(from: CommCacheInput): CommCache {
        return new CommCache(from);
    }

    countError(obj: CommCacheInput) {
        return [new Error('Invalid operation')];
    }
    
    // protected onLoad(r: any) {
    //     if (Array.isArray(this.queryListResult)) {
    //         let loadedDatas: Array<GetCommCacheInput> = [];
    //         for ( let c1 = 0; c1 < this.getParsedItems.length; c1 ++) {
    //             let currentItem = this.getParsedItems[c1];
    //             if ( currentItem ) {
    //                 loadedDatas.
    //             }
    //         }
    //     }
    // }

    parseDelete(obj: CommCache) {
        return this.parseClientDelete(obj);
    }

}

export default new CommCacheStore();


// WEBPACK FOOTER //
// ./src/stores/application/commCache.ts